<template>
  <el-dialog
    title="新增工作单类型"
    :visible.sync="dialogVisible"
    width="500px"
    @close="resetForm"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <!-- 父级类型选择 - 修复回显问题 -->
      <el-form-item label="父级类型" prop="parentId">
        <el-select
          v-model="form.parentId"
          placeholder="请选择父级类型（为空则新增为一级类型）"
          style="width: 100%"
          clearable
          filterable
          @change="handleParentChange"
        >
          <el-option label="新增为一级类型" value=""></el-option>
          <el-option
            v-for="item in rootTypeList"
            :key="item.wtId"
            :label="item.typeName"
            :value="item.wtId"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- 类型名称 -->
      <el-form-item label="类型名称" prop="typeName">
        <el-input
          v-model="form.typeName"
          placeholder="请输入类型名称"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注">
        <el-input
          v-model="form.remark"
          type="textarea"
          placeholder="请输入备注信息"
          rows="3"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveWorkType } from "@/api/oa/workTypeApi";

export default {
  name: "AddWorkType",
  props: {
    // 接收父组件传递的一级类型列表
    rootTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        parentId: "", // 父级wtId
        typeName: "",
        remark: "",
      },
      rules: {
        typeName: [
          { required: true, message: "请输入类型名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 打开弹窗，接收父级信息（修复回显逻辑）
    open(parentInfo = {}) {
      // 重置表单
      this.resetForm();

      // 设置默认选中的父级wtId
      this.form.parentId = parentInfo.parentId || "";

      // 打开弹窗
      this.dialogVisible = true;
    },

    // 父级类型变更时的处理（确保展示正确）
    handleParentChange(val) {
      // 无需额外处理，el-select会自动根据value匹配label展示
      console.log("选中的父级wtId：", val);
    },

    // 重置表单
    resetForm() {
      this.form = {
        parentId: "",
        typeName: "",
        remark: "",
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },

    // 提交表单（适配wtId字段）
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();

        // 构造提交数据（适配后端字段）
        const submitData = {
          ...this.form,
          parentId: this.form.parentId, // 父级ID字段改为parentWtId（根据后端实际字段调整）
          communityId: this.$parent.communityId, // 从父组件获取社区ID
        };

        // 调用新增接口
        await saveWorkType(submitData);
        this.$message.success("新增工作单类型成功");
        this.dialogVisible = false;
        // 通知父组件刷新列表
        this.$emit("success");
      } catch (error) {
        this.$message.error("新增失败：" + (error.message || "请稍后重试"));
        console.error("新增工作单类型失败：", error);
      }
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
.el-select {
  width: 100%;
}
</style>
